import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { CsvUploadService } from '../service/csv-upload.service';
import { UserInfo } from '../service/Model/UserInfo';

@Component({
  selector: 'app-maklerpaket-upload-kraft',
  templateUrl: './app.maklerpaket-upload.kraft.html',
  styleUrls: ['./app.maklerpaket-upload.kraft.scss'],
})
export class AppMaklerpaketUploadKraft implements OnInit {

  //fileName: string;
  //vtnr: string;
  newTeilpaket: any = {};

  regexFile : string = "^[-\\w]+\\.([gG][dD][vV]|[xX][lL][sS][xX]?)$";

  isReadyForUpload: boolean;
  isOnload : boolean = false;
  isVtnrOk : boolean = false;
  isPackageNameOk : boolean = false;
  isFileNameOk : boolean = false;

  loadBarTimer : number = 0;
  fileForUpload: File;
  @Input()
  userInfo: UserInfo;

  @Output()
  uploadStatusEvent = new EventEmitter<{result: any, newTeilpaket: any}>();
  @Output()
  abbruchEvent = new EventEmitter<boolean>();

  constructor(private snackBar: MatSnackBar,
              private csvUploadService: CsvUploadService) {
  }

  private static isValidFile(file: File): boolean {
    let fileExtension = file.name.split('.').pop();
    return (fileExtension.toLowerCase() === "gdv"
      //||fileExtension.toLowerCase() === "dat"
        || fileExtension.indexOf("xls") > -1
      //  || fileExtension.toLowerCase() === "csv"
    );
  }

  ngOnInit(): void {
    this.isReadyForUpload = false;
  }

  uploadFile() {
    if (this.isReadyForUpload) {
      console.log("Beschreibung and vtnr ok");
     this.newTeilpaket.userid = this.userInfo.bensl;
     this.uploadMakpakKraft(this.fileForUpload);
    } else {
      this.snackBar.open("Bitte geben sie gültige Daten für das Paket ein!", null,
        {duration: 2000});
    }
  }

  changeListener(files: FileList): void {
    this.checkInFile(files);
    this.checkFileName();
    if (this.isVtnrOk && this.isPackageNameOk && this.isFileNameOk) {
      this.isReadyForUpload = true;
    }
    else {
      this.isReadyForUpload = false;
    }
  }

  private checkInFile(inputValue: FileList): void {
    const file: File = inputValue[0];
    var fileCheck = AppMaklerpaketUploadKraft.isValidFile(file);
    if (fileCheck) {
      this.fileForUpload = file;
      this.newTeilpaket.dateiname = file.name;
      this.isFileNameOk = true;
    } else {
      this.snackBar.open("Diese Datei kann nicht hochgeladen werden: " + file.name, null, {duration: 2000});
    }

  }

  checkFileName() : void {
    this.isFileNameOk = this.newTeilpaket.dateiname.match(this.regexFile);
  }

  changeDone(elementid: string) {
    console.log("changeDone");
    if (!document.getElementById(elementid).classList.contains("ng-invalid")) {
      if (elementid == 'beschr') this.isPackageNameOk = true;
      if (elementid == 'vtnr') this.isVtnrOk = true;
     }
     else {
      if (elementid == 'beschr') this.isPackageNameOk = false;
      if (elementid == 'vtnr') this.isVtnrOk = false;
    }
     if (this.isVtnrOk && this.isPackageNameOk && this.isFileNameOk) {
       this.isReadyForUpload = true;
     }
     else {
      this.isReadyForUpload = false;
     }
  }


  // calculateLoadbarPossibleTime(file: any){
  //   // let additionalTime = 10000;
  //   let calculatedTimeDependsOnFileSize = file.length*1000/20;
  //   calculatedTimeDependsOnFileSize=(calculatedTimeDependsOnFileSize)/100;
  //   console.log("calculatedTimeDependsOnFileSize: " +calculatedTimeDependsOnFileSize);
  //   let sekFormat = (file.length/50).toString().split(".");
  //   console.log("loadBarTimer: " +this.loadBarTimer);
  //   this.snackBar.open("Der Vorgang dauert maximal: "+ sekFormat[0]+ " Sekunden.", null, {duration: calculatedTimeDependsOnFileSize+30000, panelClass: ["bgc-green-400"]});
  //   let interval = setInterval(() => {
  //     this.loadBarTimer = this.loadBarTimer + 1;
  //
  //     if(this.loadBarTimer >= 100) {
  //       this.loadBarTimer=0;
  //       clearInterval(interval);
  //     }
  //   }, calculatedTimeDependsOnFileSize);
  // }

  private uploadMakpakKraft(file: File) {
    this.snackBar.open("Das Hochladen der Datei kann einige Sekunden in Anspruch nehmen.", null, {
      duration: 4000,
      panelClass: ["az-message-bar", "bgc-green-400"]
    })
    this.csvUploadService.uploadMakpakKraft(file, this.newTeilpaket)
      .subscribe(
        (result: any) => {
          this.isOnload=false
          console.log("to result?");
          if (result != null && JSON.stringify(result).indexOf("BAD_GDV") > 0) {
            this.snackBar.open("Die Datei hat eine falsche Struktur!", null, {
              duration: 2000,
              panelClass: ["az-message-bar", "bgc-red-400"]
          })}
          else if (result != null) {
            console.log(result);
             this.uploadSuccess(result.mpDetails, result.mpOrigin);
          }
        },
        (error) => {
          this.snackBar.open("Es ist ein Fehler beim Hochladen der Datei aufgetreten!", null, {
            duration: 4000,
            panelClass: ["az-message-bar", "bgc-red-400"]
          });
          this.errorWithUpload();
        }
      );
  }

  private uploadSuccess(result: any, newTeilpaket : any) {
    this.reset();
    this.uploadStatusEvent.emit({result, newTeilpaket});
  }

  private errorWithUpload() {
    this.reset();
    this.uploadStatusEvent.emit(null);
  }

  uploadFileAbbruch() {
    this.reset();
    this.abbruchEvent.emit(true);
  }

  private reset() {
    this.newTeilpaket = null;
    this.isReadyForUpload = false;
    this.isPackageNameOk = false;
    this.isVtnrOk = false;
    this.isFileNameOk = false;
    this.fileForUpload = null;
    this.isOnload = false;
  }

}
